<template lang="html">
    <section class="zoomer">
        <div class="zoomer-slide">
            <b-carousel
                id="carousel1"
                controls
                label-prev=""
                label-next=""
                background="white"
                :interval="0"
                v-model="slide"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
            >
                <b-carousel-slide v-for="(figure, key) in getFigures()" :key="key">
                    <img
                        slot="img"
                        :id="action.idImg"
                        class="d-block img-fluid w-100"
                        style="margin: 0 auto; max-height: 100vh"
                        width="auto"
                        :src="baseUrl + figure.big"
                    />
                </b-carousel-slide>
            </b-carousel>
        </div>
    </section>
</template>

<script lang="js">
import Globals from '../../globals.js'
import {BCarousel} from 'bootstrap-vue';

export default {
    name: 'zoomer',
    props: [
        'action'
    ],
    components: {
        'b-carousel': BCarousel
    },
    data () {
        return {
            listFigure: '',
            baseUrl: Globals.getBaseUrl(),
            slide: 0,
            sliding: null
        }
    },
    mounted () {
    },
    created () {
    },
    methods: {
        getFigures () {
            this.listFigure = this.action.dataImg
            // console.log('imagesss::', this.action.dataImg)
            this.slide = this.action.order - 1
            return this.listFigure
        },
        onSlideStart (slide) {
            this.slide = this.slide

            // this.controls = !!(Object.values(this.listFigure).length > 0)
            this.sliding = false
        },
        onSlideEnd (slide) {
            this.sliding = false
        }
    },
    computed: {}
}
</script>

<style scoped lang="scss">
.zoomer {
}
</style>



// WEBPACK FOOTER //
// Zoomer.vue?45fb8c91